export const HAFHNotificationsSeed = {
  en: [
    {
      id: 1,
      from: "manager",
      message: "Gate closing time changed to 10:30 PM from tomorrow",
      time: "2 Hrs Ago",
      read: false,
    },
    {
      id: 2,
      from: "owner",
      message: "Maintenance work in Block B this weekend",
      time: "Yesterday",
      read: true,
    },
    {
      id: 3,
      from: "mess",
      message: "Special Biryani for Sunday Lunch",
      time: "3 Days Ago",
      read: true,
    },
    {
      id: 4,
      from: "admin",
      message: "New hostel guidelines updated",
      time: "1 Week Ago",
      read: false,
    },
    {
      id: 5,
      from: "manager",
      message: "Visitor timing restricted after 8 PM",
      time: "Today",
      read: false,
    },
    {
      id: 6,
      from: "transporter",
      message: "Transit timing restricted after 8 PM",
      time: "Today",
      read: false,
    },
  ],

  hi: [
    {
      id: 1,
      from: "manager",
      message: "कल से गेट बंद होने का समय 10:30 बजे होगा",
      time: "2 Hrs Ago",
      read: false,
    },
    {
      id: 2,
      from: "owner",
      message: "इस सप्ताहांत ब्लॉक बी में रखरखाव कार्य",
      time: "Yesterday",
      read: true,
    },
    {
      id: 3,
      from: "mess",
      message: "रविवार को स्पेशल बिरयानी",
      time: "3 Days Ago",
      read: true,
    },
    {
      id: 4,
      from: "admin",
      message: "नए हॉस्टल नियम अपडेट किए गए",
      time: "1 Week Ago",
      read: false,
    },
    {
      id: 5,
      from: "manager",
      message: "8 बजे के बाद विजिटर अनुमति नहीं",
      time: "Today",
      read: false,
    },
  ],

  mr: [
    {
      id: 1,
      from: "manager",
      message: "उद्या पासून गेट बंद होण्याची वेळ 10:30 PM",
      time: "2 Hrs Ago",
      read: false,
    },
    {
      id: 2,
      from: "owner",
      message: "या आठवड्यात ब्लॉक बी मध्ये देखभाल काम",
      time: "Yesterday",
      read: true,
    },
    {
      id: 3,
      from: "mess",
      message: "रविवारी स्पेशल बिर्याणी",
      time: "3 Days Ago",
      read: true,
    },
  ],
};

export const HAFHSeed = {
  en: {
    ownerStats: {
      occupancy: 87,
      revenue: "12.4L",
      profitIndex: 78,
      hostels: 3,
    },

    messages: [
      { from: "Parent", message: "My child is adjusting well.", time: "2h ago" },
      { from: "Student", message: "WiFi speed improved 👍", time: "Today" },
      { from: "Manager", message: "Gate closes at 10 PM", time: "Today" },
      { from: "Mess", message: "Special Biryani Sunday", time: "Yesterday" },
      { from: "Admin", message: "Monthly report ready", time: "1d ago" },
      { from: "Parent", message: "Food quality is good", time: "3d ago" },
      { from: "Student", message: "Need extra study room", time: "1w ago" },
      { from: "Manager", message: "Inspection completed", time: "2d ago" },
    ],

    attendance: {
      students: [
        {
          code: "STU101",
          name: "Aman Sharma",
          room: "A-304",
          logs: [
            { date: "1 May", time: "9:10 AM", type: "IN" },
            { date: "1 May", time: "8:30 PM", type: "OUT" },
          ],
        },
        {
          code: "STU102",
          name: "Riya Patel",
          room: "B-112",
          logs: [
            { date: "1 May", time: "9:20 AM", type: "IN" },
            { date: "1 May", time: "7:50 PM", type: "OUT" },
          ],
        },
      ],
    },

    messMenu: {
      today: "Rice, Dal, Paneer, Roti",
      tomorrow: "Fried Rice, Manchurian",
      week: "Weekly rotating veg & non-veg plan",
    },
  },

  hi: {
    ownerStats: {
      occupancy: 87,
      revenue: "12.4L",
      profitIndex: 78,
      hostels: 3,
    },

    messages: [
      { from: "माता-पिता", message: "मेरा बच्चा अच्छी तरह से एडजस्ट कर रहा है", time: "2 घंटे पहले" },
      { from: "छात्र", message: "वाईफाई बेहतर हुआ 👍", time: "आज" },
      { from: "वार्डन", message: "गेट 10 बजे बंद होगा", time: "आज" },
      { from: "मेस", message: "रविवार बिरयानी स्पेशल", time: "कल" },
      { from: "एडमिन", message: "मासिक रिपोर्ट तैयार", time: "1 दिन पहले" },
    ],

    attendance: {
      students: [
        {
          code: "STU101",
          name: "अमन शर्मा",
          room: "A-304",
          logs: [
            { date: "1 मई", time: "9:10 AM", type: "IN" },
            { date: "1 मई", time: "8:30 PM", type: "OUT" },
          ],
        },
      ],
    },

    messMenu: {
      today: "चावल, दाल, पनीर, रोटी",
      tomorrow: "फ्राइड राइस, मंचूरियन",
      week: "साप्ताहिक मेनू योजना",
    },
  },
};

export const posts = {
    myPosts: [{ id: 1, content: "Just finished reading 'Atomic Habits' 📖", points: 15, time: "2h ago" }],
    friendsPosts: [{ id: 3, user: "Riya Patel", content: "Crushed my attendance this week! 🔥", time: "1h ago" }],
    ownerPosts: [{ id: 5, user: "Mr. Rajesh Verma (Owner)", content: "Hostel maintenance completed.", time: "Yesterday" }],
    managerPosts: [{ id: 6, user: "Manager Mrs. Meena Rao", content: "Gate closes at 10:00 PM sharp.", time: "Today" }],
  };

export const SEED_EMERGENCIES = [
    {
      id: 1,
      role: "student",
      userName: "Rahul Sharma",
      roomNumber: "A-203",
      reason: "Chest pain and breathing difficulty",
      timestamp: "2026-05-17 12:42 PM",
      geo: "19.0760, 72.8777",
      severity: "critical",
    },

    {
      id: 2,
      role: "manager",
      userName: "Mrs. Fernandes",
      reason: "Fight reported in Block B",
      timestamp: "2026-05-17 12:51 PM",
      geo: "19.0765, 72.8781",
      severity: "high",
    },

    {
      id: 3,
      role: "mess",
      userName: "Kitchen Supervisor",
      reason: "Gas leakage suspected",
      timestamp: "2026-05-17 01:02 PM",
      geo: "19.0759, 72.8771",
      severity: "critical",
    },

    {
      id: 4,
      role: "parent",
      userName: "Mrs. Verma",
      reason: "Unable to contact student since morning",
      timestamp: "2026-05-17 01:05 PM",
      severity: "medium",
    },
  ];

export const HAFHOwnerSeed = {
  en: {
    // ✅ KPIs (kept for future use)
    kpis: {
      occupancy: 87,
      revenue: "₹12.4L",
      profitIndex: 78,
      activeHostels: 3,
    },

    // ✅ HOSTELS (merged with attendance)
    hostels: [
      {
        id: 1,
        name: "Alpha Hostel",
        place: "Mumbai",
        manager: "Mr. Sharma",
        seats: 100,

        students: [
          {
            id: 1,
            code: "STU001",
            name: "Aman Sharma",
            room: "A-304",
            parent: "Mr. Sharma",
            food: "Veg",

            attendance: [
              { date: "2026-05-01", type: "Gate", in: "08:10", out: "18:45" },
              { date: "2026-05-01", type: "Room", in: "22:30", out: "06:30" }, 
              { date: "2026-05-01", type: "Mess", in: "13:00", out: "13:30" },
              { date: "2026-05-01", type: "Activity", in: "17:00", out: "18:00" } 
            ]
          },
          {
            id: 2,
            code: "STU002",
            name: "Riya Patel",
            room: "B-112",
            parent: "Mr. Patel",
            food: "Veg",

            attendance: [
              { date: "2026-05-01", type: "Gate", in: "09:05", out: "-" }
            ]
          }
        ]
      }
    ],

    // ✅ MESSAGES (flattened + multilingual ready)
    messages: [
      {
        id: 1,
        date: "1 May",
        from: "parent",
        message: "Is my child attending regularly?",
        priority: "High"
      },
      {
        id: 2,
        date: "1 May",
        from: "student",
        message: "WiFi is slow in Block A",
        priority: "Low"
      },
      {
        id: 3,
        date: "1 May",
        from: "manager",
        message: "Gate timing updated",
        priority: "Low"
      }
    ],

    // ✅ MESS (merged with weekly idea)
    mess: [
      { day: "Mon", menu: "Rice + Dal", rating: 4 },
      { day: "Tue", menu: "Kadhi + Roti", rating: 5 },
      { day: "Wed", menu: "Chole + Rice", rating: 4 }
    ],

    // ✅ ACTIVITIES
    activities: [
      {
        name: "Cricket",
        type: "Outdoor",
        location: "Ground"
      },
      {
        name: "Chess",
        type: "Indoor",
        location: "Hall"
      }
    ],

    // ✅ RANKINGS
    rankings: {
      students: [
        { name: "Aman Sharma", score: 95 },
        { name: "Riya Patel", score: 90 }
      ]
    },

    // ✅ CONTACTS
    contacts: [
      { title: "Police", phone: "100" },
      { title: "Ambulance", phone: "102" }
    ],

    // ✅ PHOTOS
    photos: [
      { by: "Manager", caption: "Sports Day Event" },
      { by: "Student", caption: "Mess Food Festival" }
    ]
  },

  // ✅ HINDI (minimal but working)
  hi: {
    hostels: [
      {
        id: 1,
        name: "अल्फा हॉस्टल",
        place: "मुंबई",
        manager: "शर्मा जी",
        seats: 100,

        students: [
          {
            id: 1,
            code: "STU001",
            name: "अमन शर्मा",
            room: "A-304",
            parent: "शर्मा जी",
            food: "शाकाहारी",

            attendance: [
              { date: "2026-05-01", type: "गेट", in: "08:10", out: "18:45" }
            ]
          }
        ]
      }
    ],

    messages: [
      {
        id: 1,
        date: "1 मई",
        from: "parent",
        message: "क्या मेरा बच्चा नियमित है?",
        priority: "उच्च"
      }
    ],

    mess: [
      { day: "सोम", menu: "चावल + दाल", rating: 4 }
    ],

    activities: [
      {
        name: "क्रिकेट",
        type: "बाहरी",
        location: "मैदान"
      }
    ],

    rankings: {
      students: [
        { name: "अमन शर्मा", score: 95 }
      ]
    },

    contacts: [
      { title: "पुलिस", phone: "100" }
    ],

    photos: [
      { by: "वार्डन", caption: "कार्यक्रम फोटो" }
    ]
  }
};

export const MessMenuSeed = {
  en: {
    today: [
      {
        id: "s1",
        option: "Veg",
        timing: "Breakfast",
        portion: "250g",
        nutrients: "Carbs: 40g • Protein: 8g",
        label: "Poha + Tea"
      },
      {
        id: "s2",
        option: "Veg",
        timing: "Lunch",
        portion: "400g",
        nutrients: "Carbs: 60g • Protein: 15g",
        label: "Dal Rice + Sabji"
      }
    ],
    tomorrow: [
      {
        id: "s3",
        option: "Veg",
        timing: "Breakfast",
        portion: "250g",
        nutrients: "Carbs: 35g • Protein: 6g",
        label: "Idli + Sambar"
      }
    ]
  },

  hi: {
    today: [
      {
        id: "s1",
        option: "शाकाहारी",
        timing: "नाश्ता",
        portion: "250g",
        nutrients: "कार्ब्स: 40g • प्रोटीन: 8g",
        label: "पोहा + चाय"
      },
      {
        id: "s2",
        option: "शाकाहारी",
        timing: "दोपहर",
        portion: "400g",
        nutrients: "कार्ब्स: 60g • प्रोटीन: 15g",
        label: "दाल चावल + सब्जी"
      }
    ],
    tomorrow: [
      {
        id: "s3",
        option: "शाकाहारी",
        timing: "नाश्ता",
        portion: "250g",
        nutrients: "कार्ब्स: 35g • प्रोटीन: 6g",
        label: "इडली सांभर"
      }
    ]
  }
};

export const HAFHDirectorSeed = {
  en: {
    director: {
      id: 1,
      name: "Think5Whys Director",
      address: "Mumbai, India",
      dateJoined: "2026-01-01",
      isActive: true,

      advisors: [
        {
          id: 1,
          name: "Advisor A",
          specialization: "Operations",
          isActive: true,
        },
        {
          id: 2,
          name: "Advisor B",
          specialization: "Finance",
          isActive: true,
        },
        {
          id: 3,
          name: "Advisor C",
          specialization: "Compliance",
          isActive: true,
        },
      ],
      institutions: [
        {
          id: 1,
          name: "Alpha Hostel Group",
          type: "Hostel Network",
          location: "Mumbai",
          isActive: true,
        },

        {
          id: 2,
          name: "Beta Hostel Group",
          type: "Hostel Network",
          location: "Pune",
          isActive: true,
        },
        {
          id: 3,
          name: "Gamma Hostel Group",
          type: "Hostel Network",
          location: "Bangalore",
          isActive: true,
        },
      ],
      hostels: [
        {
          id: 1,
          name: "Alpha Hostel",
          place: "Mumbai Central",
          manager: "Mr. Sharma",
          seats: 100,
          isActive: true,
        },
        {
          id: 2,
          name: "Alpha Annex",
          place: "Andheri",
          manager: "Mr. Verma",
          seats: 80,
          isActive: true,
        },
        {
          id: 3,
          name: "Alpha Residency",
          place: "Powai",
          manager: "Mrs. Iyer",
          seats: 120,
          isActive: true,
        },
      ],
      retailCustomers: [
        {
          id: 1,
          customerCode: "CUST001",
          customerName: "Aman Sharma",
          address: "Mumbai",
          isActive: true,
        },
        {
          id: 2,
          customerCode: "CUST002",
          customerName: "Riya Patel",
          address: "Pune",
          isActive: true,
        },
        {
          id: 3,
          customerCode: "CUST003",
          customerName: "Karan Mehta",
          address: "Bangalore",
          isActive: true,
        },
      ],
      messages: [
        {
          id: 1,
          date: "2026-05-01",
          from: "parent",
          message: "Is attendance regular?",
          priority: "High",
        },
        {
          id: 2,
          date: "2026-05-02",
          from: "student",
          message: "WiFi issue in hostel",
          priority: "Medium",
        },
        {
          id: 3,
          date: "2026-05-03",
          from: "manager",
          message: "Gate timing updated",
          priority: "Low",
        },
      ],
      contacts: [
        { id: 1, title: "Police", phone: "100" },
        { id: 2, title: "Ambulance", phone: "102" },
        { id: 3, title: "Fire", phone: "101" },
      ],
    },
  },
};


export const students = [
    { id: 1, name: "Aman Sharma", score: 88, room: "A-304", rank: 3 },
    { id: 2, name: "Riya Patel", score: 76, room: "B-112", rank: 7 },
    { id: 3, name: "Kabir Singh", score: 92, room: "A-205", rank: 1 },
  ];